import { UserInterfaceState } from '@/lib/types/userInterfaceState';

export const emptyUserInterfaceState: UserInterfaceState = {
  menuOpen: false,
  menuView: '',
};
